import React from "react";
import ImageSelector from "../../components/ImageSelector";

export default function PickingImage() {
  return <ImageSelector />;
}
